import PropTypes from 'prop-types';
import React, {createContext, useContext} from 'react';

export const FaqPageContext = createContext({});

/** @returns {{settings: App.FaqPageSetting, isPreview: boolean, getData: function, putData: function, postData: function, i18n: function}|*} */
export const useFaqPageContext = () => useContext(FaqPageContext) || {};

export const FaqPageProvider = ({children, value = {}}) => {
  return (
    <FaqPageContext.Provider
      value={{
        getData: async () => ({}),
        putData: async () => {},
        postData: async () => {},
        ...value
      }}
    >
      {children}
    </FaqPageContext.Provider>
  );
};

FaqPageProvider.propTypes = {
  children: PropTypes.any,
  value: PropTypes.object
};
